import { render, staticRenderFns } from "./riskPlan.vue?vue&type=template&id=984b2b8e"
import script from "./riskPlan.vue?vue&type=script&lang=js"
export * from "./riskPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('984b2b8e')) {
      api.createRecord('984b2b8e', component.options)
    } else {
      api.reload('984b2b8e', component.options)
    }
    module.hot.accept("./riskPlan.vue?vue&type=template&id=984b2b8e", function () {
      api.rerender('984b2b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskPlan.vue"
export default component.exports